// extracted by mini-css-extract-plugin
export var button = "ReadMoreList-module--button--88e47";
export var content = "ReadMoreList-module--content--48eca";